import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Secondary, SvgIcon, Text } from "@cinch-labs/design-system";
import { TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { Wrapper } from "@cinch-nx/shared-ui";
import Image from "next/image";
import { useCallback } from "react";
import { Form } from "react-final-form";
import FieldWrapper from "./field-wrapper/field-wrapper.component";
import styles from "./part-ex.module.css";
import TextFieldWrapper from "./text-field-wrapper/text-field-wrapper.component";
var sanitiseVrm = function(vrm) {
    return vrm.replace(/\s/g, "");
};
export var partExchangeCalculatorId = "part-exchange-calculator";
export var partExchangeContentPageUrl = "/part-exchange";
export var partExchangeCalculatorUrl = "/part-exchange/calculator";
var PartExchangeSection = function(param) {
    var title = param.title, subtitle = param.subtitle, placeholder = param.placeholder, label = param.label, image = param.image, link = param.link, ctaText = param.ctaText;
    var trackEvent = useAnalytics().trackEvent;
    var onCtaClick = useCallback(function(formData) {
        var sanitisedVrm = sanitiseVrm(formData.vrm);
        var label = "part-exchange-calculator";
        trackEvent({
            eventName: label,
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: "click",
                    category: "button",
                    label: label,
                    action: "search"
                }
            }
        });
        window.location.href = "".concat(partExchangeCalculatorUrl, "?vrm=").concat(sanitisedVrm);
    }, []);
    var _alt;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        className: {
            container: styles.container
        },
        children: [
            /*#__PURE__*/ _jsx("section", {
                id: partExchangeCalculatorId,
                className: styles["partExchangeMarketingSectionContainer"],
                children: /*#__PURE__*/ _jsxs("div", {
                    id: partExchangeCalculatorId,
                    className: styles["partExchangeMarketingSectionWrapper"],
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles["partExchangeMarketingSectionLeftSection"],
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: styles["partExchangeMarketingSectionContent"],
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        element: "h2",
                                        type: "vehiclePrice",
                                        className: styles["partExchangeMarketingSectionTitle"],
                                        children: title
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        element: "h3",
                                        type: "vehicleSubTitle",
                                        className: styles["partExchangeMarketingSectionSubTitle"],
                                        children: subtitle
                                    }),
                                    /*#__PURE__*/ _jsx(Form, {
                                        onSubmit: function(formData) {
                                            return onCtaClick(formData);
                                        },
                                        render: function(param) {
                                            var handleSubmit = param.handleSubmit;
                                            return /*#__PURE__*/ _jsx("form", {
                                                onSubmit: handleSubmit,
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: styles["vrmInputWrapper"],
                                                    children: [
                                                        /*#__PURE__*/ _jsx(FieldWrapper, {
                                                            id: "vrmInput",
                                                            name: "vrm",
                                                            required: true,
                                                            component: TextFieldWrapper,
                                                            fullWidth: true,
                                                            "aria-label": label,
                                                            classNames: {
                                                                label: {
                                                                    label: styles.vrmInputLabel
                                                                },
                                                                input: styles.vrmInput
                                                            },
                                                            label: label,
                                                            placeholder: placeholder,
                                                            maxLength: 10
                                                        }),
                                                        /*#__PURE__*/ _jsx(Secondary, {
                                                            type: "submit",
                                                            variant: "alternative",
                                                            href: "",
                                                            children: ctaText
                                                        })
                                                    ]
                                                })
                                            });
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles["partExchangeMarketingSectionImage"],
                            children: /*#__PURE__*/ _jsx(Image, {
                                src: image.filename,
                                alt: (_alt = image.alt) !== null && _alt !== void 0 ? _alt : "",
                                layout: "responsive",
                                width: 410,
                                height: 362
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.infoWrapper,
                children: /*#__PURE__*/ _jsxs("a", {
                    href: "/part-exchange",
                    className: styles.findMore,
                    "data-testid": "part-exchange-button",
                    onClick: function() {
                        trackEvent({
                            eventName: "Home page marketing block CTA",
                            type: TrackingEventTypes.ADOBE,
                            data: {
                                event: {
                                    name: "click",
                                    category: "button",
                                    label: "Home page marketing block CTA",
                                    action: "navigate to part-exchange"
                                }
                            }
                        });
                    },
                    children: [
                        /*#__PURE__*/ _jsx(SvgIcon, {
                            name: "info",
                            height: 20,
                            color: "toreaBay"
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: styles.findMoreButton,
                            children: link
                        })
                    ]
                })
            })
        ]
    });
};
export default PartExchangeSection;
